import React from "react";
import * as SC from "./PrintPostEditorSwitch.styled";
import PostEditorFacebook from "../print-post-editors/print-post-editor-facebook/PrintPostEditorFacebook";
import PostEditorYoutube from "./../print-post-editors/print-post-editor-youtube/PrintPostEditorYoutube";
import PostEditorInstagram from "./../print-post-editors/print-post-editor-instagram/index";
import PostEditorTwitter from "./../print-post-editors/print-post-editor-twitter/PrintPostEditorTwitter";
import PostEditorLinkedIn from "./../print-post-editors/print-post-editor-linkedin/PrintPostEditorLinkedIn";
import PostEditorIndeed from "./../print-post-editors/print-post-editor-indeed/PrintPostEditorIndeed";
import PostEditorReddit from "./../print-post-editors/print-post-editor-reddit/PrintPostEditorReddit";
import PostEditorSnapchat from "./../print-post-editors/print-post-editor-snapchat/PrintPostEditorSnapchat";
import PostEditorPinterest from "./../print-post-editors/print-post-editor-pinterest/PrintPostEditorPinterest";
import PostEditorGoogleSearch from "./../print-post-editors/print-post-editor-google-search/PrintPostEditorGoogleSearch";
import PostEditorSpotify from "./../print-post-editors/print-post-editor-spotify/PrintPostEditorSpotify";
import PostEditorTikTok from "./../print-post-editors/print-post-editor-tiktok/PrintPostEditorTikTok";
import PostEditorLinkedInFeed from "./../print-post-editors/print-post-editor-linkedin-feed/PrintPostEditorLinkedInFeed";
import PostEditorSkeleton from "./../print-post-editors/print-post-editor-skeleton/PrintPostEditorSkeleton";
import { useTranslation } from "react-i18next";

const PrintPostEditorSwitch = (props) => {
  const {
    selectedPreviewChannel,
    mobile,
    postData,
    channelData,
    updatePost,
    updateChannelData,
    editable,
    clientView,
    selectedCreativeIndexToEdit,
    setSelectedCreativeIndexToEdit,
    campaignId,
    orgaId,
    shouldUseLongImage,
    mediaAssetsProps,
    mediaAssets
  } = props;

  const { t } = useTranslation();

  if (!channelData || !postData) {
    return <PostEditorSkeleton mobile={mobile} />;
  }

  const commonProps = {
    orgaId,
    postData,
    campaignId,
    channelData,
    updatePost,
    updateChannelData,
    mobile,
    editable,
    clientView,
    selectedCreativeIndexToEdit,
    setSelectedCreativeIndexToEdit,
    channel: selectedPreviewChannel,
    shouldUseLongImage,
    mediaAssetsProps,
    mediaAssets
  };

  const googleChannels = ["youtube", "google-display", "ebay-kleinanzeigen"];
  const editorComponents = {
    facebook: PostEditorFacebook,
    instagram: PostEditorInstagram,
    twitter: PostEditorTwitter,
    linkedin: PostEditorLinkedIn,
    indeed: PostEditorIndeed,
    reddit: PostEditorReddit,
    snapchat: PostEditorSnapchat,
    "google-search": PostEditorGoogleSearch,
    pinterest: PostEditorPinterest,
    spotify: PostEditorSpotify,
    tiktok: PostEditorTikTok,
    "linkedin-feed": PostEditorLinkedInFeed
  };

  const renderEditor = () => {
    if (googleChannels.includes(selectedPreviewChannel)) {
      return <PostEditorYoutube {...commonProps} />;
    }

    const EditorComponent = editorComponents[selectedPreviewChannel];
    if (EditorComponent) {
      return <EditorComponent {...commonProps} />;
    }

    return <SC.ComingSoon>{t("AVAILABLE SOON")}</SC.ComingSoon>;
  };

  return (
    <div style={{ textAlign: "right" }}>
      <div style={{ marginTop: 5 }}>{renderEditor()}</div>
    </div>
  );
};

export default PrintPostEditorSwitch;
